<template>
<div>
  <van-field 
    readonly 
    clickable
    :name="schema.name + '_' +schema.uniqid"
    :label="schema.label" 
    :placeholder="schema.placeholder" 
    :value="schema.values.join(' / ')"
    :required="schema.required === true" 
    :rules="[{ required: schema.required === true ,message:'请选择'+schema.label}]"
    @click="cascaderVisible=true"
  />

<van-popup v-model="cascaderVisible" round position="bottom">
  <van-cascader
    v-model="cascaderValue"
    title="请选择所在地区"
    :options="schema.cascader"
    :field-names="fieldNames"
    @close="cascaderVisible = false"
    @finish="onFinish"
  />
</van-popup>

</div>
</template>

<script>
// import { Notify } from 'vant';

export default {
  name: 'selectJoin',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  data:function(){
    return {
      cascaderValue:'',
      cascaderVisible:false,
      fieldNames:{
        text: 'value',
        value: 'value',
        children: 'children',
      },
    }
  },
  methods:{
    // values:[], //旧版 value defaultIndex
    // cascader:[//旧版 columns
    onFinish:function({ selectedOptions }) {
      this.cascaderVisible = false;
      // console.log('selectedOptions',selectedOptions)
      this.schema.values = selectedOptions.map((option) => option.value)
    }
  }
}
</script>

<style>

</style>